import React from 'react';
import styled from 'styled-components';

import SvgIcon, { SvgIconName } from './SvgIcon';

const ItemContainer = styled.div`
  display: flex;
`;

const Icon = styled(SvgIcon)`
  margin-right: 5px;
`;

interface Props {
  iconName: SvgIconName;
  labelKey: string;
  label: string;
}

const IconTextItem: React.FC<Props> = React.memo(({ iconName, labelKey, label }) => (
  <ItemContainer>
    <Icon name={iconName} />
    <div data-translation={labelKey}>{label}</div>
  </ItemContainer>
));

export default IconTextItem;
